import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'

function NewService() {
  return (
    <div>
        <Header />
             {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover" style={{"backgroundImage": "url('/assets/img/breadcrumb-bg.jpg')"}}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Services</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="index-2.html">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                           Services
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {/* <!-- Service Section Start --> */}
        <section class="service-section-3 fix section-padding">
            <div class="container">
                <div class="row g-4">
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
                        <div class="service-box-items-2">
                            <div class="icon">
                                <i class="flaticon-real-estate"></i>
                            </div>
                            <div class="content">
                                <h3><a href="service-details.html">Property Sales & Leasing</a></h3>
                                <p>Buy, sell, or lease premium commercial apartment units with ease.</p>
                                <a href="service-details.html" class="link-btn">
                                    <i class="flaticon-home"></i> read more
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".5s">
                        <div class="service-box-items-2">
                            <div class="icon">
                               <i class="flaticon-playground"></i>
                            </div>
                            <div class="content">
                                <h3><a href="service-details.html">Virtual Tours & Site Visits</a></h3>
                                <p>Buy, sell, or lease premium commercial apartment units with ease.</p>
                                <a href="service-details.html" class="link-btn">
                                    <i class="flaticon-home"></i> read more
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
                        <div class="service-box-items-2">
                            <div class="icon">
                               <i class="flaticon-store"></i>
                            </div>
                            <div class="content">
                                <h3><a href="service-details.html">Investment Consultation</a></h3>
                                <p>Buy, sell, or lease premium commercial apartment units with ease.</p>
                                <a href="service-details.html" class="link-btn">
                                    <i class="flaticon-home"></i> read more
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
                        <div class="service-box-items-2">
                            <div class="icon">
                               <i class="flaticon-appraisal"></i>
                            </div>
                            <div class="content">
                                <h3><a href="service-details.html">Property Sales & Leasing</a></h3>
                                <p>Buy, sell, or lease premium commercial apartment units with ease.</p>
                                <a href="service-details.html" class="link-btn">
                                    <i class="flaticon-home"></i> read more
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".5s">
                        <div class="service-box-items-2">
                            <div class="icon">
                               <i class="flaticon-virtual-tour"></i>
                            </div>
                            <div class="content">
                                <h3><a href="service-details.html">Virtual Tours & Site Visits</a></h3>
                                <p>Buy, sell, or lease premium commercial apartment units with ease.</p>
                                <a href="service-details.html" class="link-btn">
                                    <i class="flaticon-home"></i> read more
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
                        <div class="service-box-items-2">
                            <div class="icon">
                                <i class="flaticon-financial-advisor"></i>
                            </div>
                            <div class="content">
                                <h3><a href="service-details.html">Investment Consultation</a></h3>
                                <p>Buy, sell, or lease premium commercial apartment units with ease.</p>
                                <a href="service-details.html" class="link-btn">
                                    <i class="flaticon-home"></i> read more
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* <!-- Cta Check Section Start --> */}
        <section class="cta-check-section fix section-bg bg-white-style section-padding pb-0">
            <div class="cta-shape">
                <img src="assets/img/home-2/cta-shape.png" alt="img"/>
            </div>
            <div class="container">
                <div class="cta-check-wrapper">
                    <div class="check-abode-items">
                        <div class="left-items">
                            <div class="section-title mb-0">
                                <h2 class="wow fadeInUp" data-wow-delay=".3s">
                                    Check Out Our <br/> Contemporary Abode.
                                </h2>
                                <p class="mt-3 wow fadeInUp" data-wow-delay=".5s">
                                    Explore a thoughtfully designed modern living space that blends sleek architecture with smart amenities. Perfect for those who seek style, comfort, and convenience—all in one beautiful, move-in-ready home.
                                </p>
                            </div>
                        </div>
                        <div class="right-items">
                            <div class="client-info-box wow fadeInUp" data-wow-delay=".3s">
                                <div class="client-item">
                                    <div class="thumb">
                                        <img src="assets/img/home-2/client-01.jpg" alt="img"/>
                                    </div>
                                    <div class="content">
                                        <h5>Shikhon Islam</h5>
                                        <span>CEO of Realar</span>
                                    </div>
                                </div>
                                <img src="assets/img/home-2/sing.png" alt="img"/>
                            </div>
                            <a href="contact.html" class="theme-btn wow fadeInUp" data-wow-delay=".5s">
                                REQUEST A VISIT <i class="flaticon-home"></i> 
                            </a>
                        </div>
                    </div>
                    <div class="cta-image-items parallaxie bg-cover" style={{"backgroundImage": "url('/assets/img/home-2/cta-bg.jpg')"}}>
                        <span class="text-line">
                            CONSULTING
                        </span>
                        <div class="cta-content">
                            <h2 class="wow fadeInUp" data-wow-delay=".3s">We Make Buying and Selling Easy</h2>
                            <p class="wow fadeInUp" data-wow-delay=".5s">
                                We simplify every step of your real estate journey. From finding the perfect home to finalizing the deal, our expert team ensures a smooth, stress-free experience for buyers and sellers alike.
                            </p>
                            <a href="contact.html" class="theme-btn wow fadeInUp" data-wow-delay=".7s">
                               GET STARTED <i class="flaticon-home"></i> 
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* <!-- Testimonial Section Start --> */}
        <section class="testimonial-section-2 fix section-padding">
            <div class="left-shape">
                <img src="assets/img/home-2/testimonial/left-shape.png" alt="img"/>
            </div>
            <div class="container">
                <div class="testimonial-wrapper-2">
                    <div class="row g-4 align-items-center">
                        <div class="col-lg-6">
                            <div class="testimonial-left-content">
                                <div class="section-title mb-0">
                                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i>Testimonial</h5>
                                    <h2 class="wow fadeInUp" data-wow-delay=".3s">What Our Residents <br/> Say</h2>
                                </div>
                                <p class="testi-text wow fadeInUp" data-wow-delay=".5s">
                                    Discover why our residents love calling us home—from breathtaking views and luxury finishes to unmatched service and community living, their stories reflect
                                </p>
                                <a href="contact.html" class="theme-btn wow fadeInUp" data-wow-delay=".7s">
                                    VIEW ALL REVIEW <i class="flaticon-home"></i> 
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="testimonial-right-items bg-cover"  style={{backgroundImage: "url('/assets/img/home-2/testimonial/map-shape.png')"}}>
                                <div class="swiper testi-box-slider">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <div class="testimonial-box-2">
                                                <div class="star">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                </div>
                                                <p>
                                                    From the moment we arrived, every detail was flawless. The staff anticipated our every need, and the suite was pure perfection. We’ll be back soon!"
                                                </p>
                                                <div class="client-info">
                                                    <h4>Marvin McKinney</h4>
                                                    <span>Product Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                         <div class="swiper-slide">
                                            <div class="testimonial-box-2">
                                                <div class="star">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                </div>
                                                <p>
                                                    From the moment we arrived, every detail was flawless. The staff anticipated our every need, and the suite was pure perfection. We’ll be back soon!"
                                                </p>
                                                <div class="client-info">
                                                    <h4>Marvin McKinney</h4>
                                                    <span>Product Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                         <div class="swiper-slide">
                                            <div class="testimonial-box-2">
                                                <div class="star">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                </div>
                                                <p>
                                                    From the moment we arrived, every detail was flawless. The staff anticipated our every need, and the suite was pure perfection. We’ll be back soon!"
                                                </p>
                                                <div class="client-info">
                                                    <h4>Marvin McKinney</h4>
                                                    <span>Product Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                         <div class="swiper-slide">
                                            <div class="testimonial-box-2">
                                                <div class="star">
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                <i class="fa-solid fa-star"></i>
                                                </div>
                                                <p>
                                                    From the moment we arrived, every detail was flawless. The staff anticipated our every need, and the suite was pure perfection. We’ll be back soon!"
                                                </p>
                                                <div class="client-info">
                                                    <h4>Marvin McKinney</h4>
                                                    <span>Product Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="client-info-image">
                                    <div class="swiper testi-image-slider">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide">
                                                <div class="client-image">
                                                    <img src="assets/img/home-2/testimonial/client-01.png" alt="img"/>
                                                </div>
                                            </div>
                                             <div class="swiper-slide">
                                                <div class="client-image">
                                                    <img src="assets/img/home-2/testimonial/client-02.png" alt="img"/>
                                                </div>
                                            </div>
                                             <div class="swiper-slide">
                                                <div class="client-image">
                                                    <img src="assets/img/home-2/testimonial/client-03.png" alt="img"/>
                                                </div>
                                            </div>
                                             <div class="swiper-slide">
                                                <div class="client-image">
                                                    <img src="assets/img/home-2/testimonial/client-04.png" alt="img"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* <!-- Contact Section Start --> */}
        <section class="contact-section fix">
            <div class="container">
                <div class="contact-wrapper">
                    <div class="row">
                        <div class="col-lg-6"></div>
                        <div class="col-lg-6">
                            <div class="contact-content">
                                <div class="section-title">
                                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i> BOOK APPOINTMENT</h5>
                                    <h2 class="wow fadeInUp" data-wow-delay=".3s">Send Us Message</h2>
                                </div>
                                <form action="#">
                                    <div class="row g-4">
                                        <div class="col-lg-6 wow fadeInUp" data-wow-delay=".2s">
                                            <div class="form-clt">
                                                <input type="text" name="name" id="name" placeholder="Full Name"/>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
                                            <div class="form-clt">
                                                <input type="text" name="email" id="email" placeholder="Email address"/>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                                            <div class="form-clt">
                                                <div class="form">
                                                    <select class="single-select w-100">
                                                        <option>Real Estate</option>
                                                        <option>Property management</option>
                                                        <option>Market analysis</option>
                                                        <option>Home interior</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".6s">
                                            <div class="form-clt">
                                               <textarea name="message" id="message" placeholder="Message Here*"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                                            <button class="theme-btn" type="submit">
                                                Send Message
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="googpemap">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6678.7619084840835!2d144.9618311901502!3d-37.81450084255415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642b4758afc1d%3A0x3119cc820fdfc62e!2sEnvato!5e0!3m2!1sen!2sbd!4v1641984054261!5m2!1sen!2sbd" style={{border:'0'}} allowfullscreen="" loading="lazy"></iframe>
            </div>
        </section>
        

        {/* <!-- Footer Section Start --> */}
        <Footer/>
     
    </div>   
  )
}

export default NewService